var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog-delete"},[_c(_vm.dialog,_vm._g(_vm._b({ref:"dialog",tag:"component",on:{"agree":_vm.onAgree}},'component',_vm.$attrs,false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }